import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles((theme) => ({
  systemCheckNotifications: {
    position: "absolute",
    top: "77px",
    right: "10px",
    zIndex: 1010,
    width: "380px",
    backgroundColor: "white",
    borderRadius: "10px",
    border: `1px solid ${theme.palette.gray.medium}`,
    boxShadow: "3px 3px 3px 0px rgb(199 209 219 / 60%)",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "15px 20px",
    borderTopLeftRadius: "10px",
    borderTopRightRadius: "10px",
  },
  headerError: {
    backgroundColor: "#ffdddd",
  },
  headerRecommendation: {
    backgroundColor: theme.palette.blue.lightShade1,
  },
  title: {
    display: "flex",
    alignItems: "center",
  },
  closeBtn: {
    padding: "0",
  },
  disabled: {
    opacity: 0.2,
  },
  menuButton: {
    justifyContent: "space-between",
  },
  body: {
    padding: "15px 9px",
    display: "flex",
    flexDirection: "column",
  },
  flexCenter: {
    display: "flex",
    justifyContent: "center",
  },
  footer: {
    borderTop: "1px solid #eaeef2",
    display: "flex",
    justifyContent: "flex-end",
    padding: "15px 20px",
  },
  actionButtonContent: {
    alignItems: "center",
  },
  statusIcon: {
    display: "flex",
    marginRight: "5px",
  },
  retryIcon: {
    marginRight: theme.spacing(0.5),
  },
}));
